// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"112":"work","420":"message","539":"misc","644":"account","857":"report","884":"admin"}[chunkId] || chunkId) + "." + {"112":"2bc97b94","368":"0de2a2c2","420":"ca694e57","539":"eec0db9f","541":"c8b7ae8e","644":"cd2d6770","857":"18d2b4dc","884":"5c6e0163","945":"5dff008a"}[chunkId] + ".js";
};